import { ref, computed, Ref, ComputedRef } from 'vue'

import { DefinitionListContentColumn, EventListColumnSelection } from '@/components/types'

export function useColumns(parentId: string, columns: Ref<DefinitionListContentColumn[] | undefined>): any {

  const columnsRef: Ref<DefinitionListContentColumn[] | undefined> = columns

  const columnsFlattened = computed(() => {
    const result: DefinitionListContentColumn[] = []

    if (!columnsRef.value) return result

    for (const column of columnsRef.value) {
      if (column.type === "stack" && column.items.length > 0) {
        for (const item of column.items) {
          result.push(item)
        }
      }
      if (!["checkbox-selection", "checkbox", "stack", "actions", "collapsible"].includes(column.type)) {
        result.push(column)
      }
    }

    return result
  })

  const storeColumnsLocalStorage = () => {
    const storageKey = `hcl-list-result-columns-${parentId}`
    localStorage.setItem(storageKey, JSON.stringify(columnsRef.value))
  }

  const onColumnsMenuSelectionChange = (event: EventListColumnSelection) => {

    if (!columnsRef.value) return

    for (const column of columnsRef.value) {
      if (column.type === "stack" && column.items.length > 0) {
        for (const item of column.items) {
          if (item.name === event.name) {
            item.hidden = !event.hidden
          }
        }
        const all = column.items.every(column => {
          return column.hidden
        })
        column.hidden = all
      } else {
        if (column.name === event.name) {
          column.hidden = !event.hidden
        }
      }
    }

    storeColumnsLocalStorage()
  }

  return {
    columnsRef,
    columnsFlattened,
    onColumnsMenuSelectionChange
  }
}
